import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router";
import swal from "sweetalert";
import { API } from "../../API";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
import { isAutheticated } from "./authhelper";

export default function Login({ headerLogo }) {
  const history = useHistory();
  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const { token } = isAutheticated();

  if (token) {
    history.push("/dashboard");
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(`${API}/api/user/login`, { ...user })
      .then((response) => {
        setLoading(false);
        // console.log("here the response", response.data);
        localStorage.setItem(
          "auth",
          JSON.stringify({
            type: response.data?.user?.role, // ✅ store selected role
            user: response.data?.user,
            token: response.data.token,
          })
        );
        // window.location.reload(); // 🔄 force reload after navigation

        history.push("/dashboard");
      })
      .catch((err) => {
        setLoading(false);
        let message = err.response?.data.message;
        swal({
          title: "Error",
          text: message,
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
      });
  };

  return (
    <div className="authentication-bg h-100">
      <div className="account-pages pt-sm-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 d-flex justify-content-center">
              <div className="text-center mt-1">
                <img
                  src={headerLogo}
                  className="mb-4 auth-logo"
                  alt="Logo"
                  style={{ height: "80px", width: "auto", maxWidth: "100%" }}
                />
              </div>
            </div>
          </div>
          <div className="row align-items-center justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card">
                <div className="card-body p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary welcome-text">
                      Welcome Back !
                    </h5>
                    <p className="text-muted">Sign In to SoComOTT</p>
                  </div>
                  {/* ✅ Role selection
                  <div className="form-group mt-3">
                    <div>
                      <label className="mr-3">
                        <input
                          type="radio"
                          name="role"
                          value="admin"
                          checked={user.role === "admin"}
                          onChange={handleChange}
                        />{" "}
                        Admin
                      </label>
                      <label>
                        <input
                          type="radio"
                          name="role"
                          value="staff"
                          checked={user.role === "staff"}
                          onChange={handleChange}
                        />{" "}
                        Staff
                      </label>
                    </div>
                  </div> */}
                  <div className="p-2 mt-4">
                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <label htmlFor="username">Email</label>
                        <input
                          type="email"
                          onChange={handleChange}
                          name="email"
                          value={user.email}
                          required
                          className="form-control input-field"
                          placeholder="Enter Email ID"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="userpassword">Password</label>
                        <input
                          type="password"
                          value={user.password}
                          name="password"
                          onChange={handleChange}
                          required
                          className="form-control input-field"
                          placeholder="Enter password"
                        />
                      </div>



                      <div className="mt-3 text-right">
                        <button
                          type="submit"
                          className="btn btn-primary w-sm waves-effect waves-light"
                          disabled={loading}
                        >
                          <ClipLoader color="white" loading={loading} size={20} />
                          {!loading && "Log In"}
                        </button>
                      </div>
                      <div className="d-flex justify-content-between mt-2">
                        <h6>
                          <Link to="/admin/forgotpassword">Forgot Password</Link>
                        </h6>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
